(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["muse-cards-browse"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-mu-form]');
    const complete=true;
    const seen=new Map();
    root.querySelectorAll('[data-mu-card]').forEach(card=>{
      const existing=seen.get(card.dataset.productId);
      if(existing){existing.dataset.cardKinds=JSON.stringify([...new Set([...JSON.parse(existing.dataset.cardKinds),card.dataset.kind])]);card.remove();}
      else{card.dataset.cardKinds=JSON.stringify([card.dataset.kind]);seen.set(card.dataset.productId,card);}
    });
    const cards = Array.from(root.querySelectorAll('[data-mu-card]'));
    const parse = value => {try{return JSON.parse(value || '[]') || [];}catch{return [];}};
    cards.forEach((card,index) => {card.dataset.order=String(index);});
    root.querySelectorAll('[data-mu-facet]').forEach(fieldset => {
      const key=fieldset.dataset.muFacet;
      const values=[...new Set(cards.flatMap(card => key==='kind' ? parse(card.dataset.cardKinds) : parse(card.dataset[key])))].filter(Boolean).sort();
      fieldset.hidden=!values.length;
      values.forEach(value => {
        const label=document.createElement('label');
        const input=document.createElement('input');
        input.type='checkbox';input.name=key;input.value=value;
        label.append(input,document.createTextNode(value));
        fieldset.querySelector('[data-mu-options]').append(label);
      });
    });
    const sort=root.querySelector('[data-mu-sort]');
    const apply=() => {
      const data=new FormData(form);
      let count=0;
      cards.forEach(card => {
        const facets=['kind','colours','flowers'].every(key => {
          const chosen=data.getAll(key);
          const values=key==='kind' ? parse(card.dataset.cardKinds) : parse(card.dataset[key]);
          return !chosen.length || chosen.some(v=>values.includes(v));
        });
        const ranges=data.getAll('budget');
        const price=Number(card.dataset.price);
        const availability=data.getAll('availability');
        const status=!availability.length||availability.includes(card.dataset.available);
        const budget=!ranges.length || ranges.some(range=>{const [min,max]=range.split(':').map(Number);return price>=min&&price<max;});
        card.hidden=!(facets&&budget&&status);if(!card.hidden)count++;
      });
      root.querySelector('[data-mu-count]').textContent=root.querySelector('[data-mu-count-template]').textContent.replace('[count]',String(count));
      let empty=root.querySelector('[data-mu-global-empty]');
      if(!empty){empty=root.querySelector('[data-mu-empty]').cloneNode(true);empty.removeAttribute('data-mu-empty');empty.setAttribute('data-mu-global-empty','');root.querySelector('.mu-results').append(empty);}
      empty.hidden=count>0||!complete;
      root.querySelectorAll('[data-mu-lane]').forEach(lane=>{
        const grid=lane.querySelector('.mu-grid');
        const items=Array.from(grid.querySelectorAll('[data-mu-card]'));
        items.sort((a,b)=>sort.value==='featured'?Number(a.dataset.order)-Number(b.dataset.order):sort.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):Number(b.dataset.price)-Number(a.dataset.price));
        items.forEach(item=>grid.append(item));
        const any=items.some(item=>!item.hidden);
        lane.hidden=!any;
        lane.querySelector('[data-mu-empty]').hidden=true;
      });
    };
    const selected=root.dataset.cardCurrent;
    form.querySelectorAll('input[name=kind]').forEach(input=>{input.checked=input.value===selected;});
    form.addEventListener('change',apply);
    form.addEventListener('reset',()=>setTimeout(apply,0));
    sort.addEventListener('change',apply);
    if(matchMedia('(max-width:600px)').matches)root.querySelector('.mu-filters').open=false;
    const preview=new URLSearchParams(location.search).get('preview_theme_id');
    if(preview)root.querySelectorAll('[data-mu-product-link]').forEach(link=>{const url=new URL(link.href);url.searchParams.set('preview_theme_id',preview);link.href=url.toString();});
    apply();
  };
  document.querySelectorAll('[data-mu-cards-root]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mu-cards-root]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muse-unified-browse"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = async root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-mu-form]');
    let complete=true;
    const nextLink=root.querySelector('[data-mu-next]');
    if(nextLink){
      form.inert=true;root.querySelector('[data-mu-sort]').disabled=true;
      root.querySelectorAll('[data-mu-lane]').forEach(lane=>{lane.hidden=!lane.querySelector('[data-mu-card]');});
      nextLink.hidden=true;
      try{
        const pages=[];
        for(let page=Number(root.dataset.muPage)+1;page<=Number(root.dataset.muPages);page++)pages.push(page);
        const batches=new Map();
        const worker=async()=>{
          while(pages.length){
            const page=pages.shift();
            const url=new URL(nextLink.href,location.href);
            url.searchParams.set(root.dataset.muPageParam||'page',String(page));
            url.searchParams.set('view',new URLSearchParams(location.search).get('view')||'');
            url.searchParams.set('section_id',root.dataset.muSection);
            const response=await fetch(url,{credentials:'same-origin'});
            if(!response.ok)throw new Error('Collection unavailable');
            const doc=new DOMParser().parseFromString(await response.text(),'text/html');
            const batch=doc.querySelector('[data-mu-occasion]');
            if(!batch)throw new Error('Missing collection');
            batches.set(page,batch);
          }
        };
        const outcomes=await Promise.allSettled([worker(),worker(),worker()]);
        [...batches.entries()].sort((a,b)=>a[0]-b[0]).forEach(([,batch])=>{
          batch.querySelectorAll('[data-mu-lane]').forEach(lane=>{
            const target=root.querySelector('[data-mu-lane="'+lane.dataset.muLane+'"] .mu-grid');
            lane.querySelectorAll('[data-mu-card]').forEach(card=>target.append(card));
          });
        });
        if(outcomes.some(result=>result.status==='rejected'))throw new Error('Incomplete collection');
        nextLink.remove();
        root.querySelector('[data-mu-loading]').remove();
      }catch(error){
        complete=false;nextLink.hidden=false;
        root.querySelector('[data-mu-loading]').textContent=root.querySelector('[data-mu-load-error]').textContent;
      }
      form.inert=false;root.querySelector('[data-mu-sort]').disabled=false;
    }
    const cards = Array.from(root.querySelectorAll('[data-mu-card]'));
    const parse = value => {try{return JSON.parse(value || '[]') || [];}catch{return [];}};
    cards.forEach((card,index) => {card.dataset.order=String(index);});
    root.querySelectorAll('[data-mu-facet]').forEach(fieldset => {
      const key=fieldset.dataset.muFacet;
      const values=[...new Set(cards.flatMap(card => key==='kind' ? [card.dataset.kind] : parse(card.dataset[key])))].filter(Boolean).sort();
      fieldset.hidden=!values.length;
      values.forEach(value => {
        const label=document.createElement('label');
        const input=document.createElement('input');
        input.type='checkbox';input.name=key;input.value=value;
        label.append(input,document.createTextNode(value));
        fieldset.querySelector('[data-mu-options]').append(label);
      });
    });
    const sort=root.querySelector('[data-mu-sort]');
    const apply=() => {
      const data=new FormData(form);
      let count=0;
      cards.forEach(card => {
        const facets=['kind','colours','flowers'].every(key => {
          const chosen=data.getAll(key);
          const values=key==='kind' ? [card.dataset.kind] : parse(card.dataset[key]);
          return !chosen.length || chosen.some(v=>values.includes(v));
        });
        const ranges=data.getAll('budget');
        const price=Number(card.dataset.price);
        const budget=!ranges.length || ranges.some(range=>{const [min,max]=range.split(':').map(Number);return price>=min&&price<max;});
        card.hidden=!(facets&&budget);if(!card.hidden)count++;
      });
      root.querySelector('[data-mu-count]').textContent=root.querySelector('[data-mu-count-template]').textContent.replace('[count]',String(count));
      let empty=root.querySelector('[data-mu-global-empty]');
      if(!empty){empty=root.querySelector('[data-mu-empty]').cloneNode(true);empty.removeAttribute('data-mu-empty');empty.setAttribute('data-mu-global-empty','');root.querySelector('.mu-results').append(empty);}
      empty.hidden=count>0||!complete;
      root.querySelectorAll('[data-mu-lane]').forEach(lane=>{
        const grid=lane.querySelector('.mu-grid');
        const items=Array.from(grid.querySelectorAll('[data-mu-card]'));
        items.sort((a,b)=>sort.value==='featured'?Number(a.dataset.order)-Number(b.dataset.order):sort.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):Number(b.dataset.price)-Number(a.dataset.price));
        items.forEach(item=>grid.append(item));
        const any=items.some(item=>!item.hidden);
        lane.hidden=!any;
        lane.querySelector('[data-mu-empty]').hidden=true;
      });
    };
    form.addEventListener('change',apply);
    form.addEventListener('reset',()=>setTimeout(apply,0));
    sort.addEventListener('change',apply);
    if(matchMedia('(max-width:600px)').matches)root.querySelector('.mu-filters').open=false;
    const preview=new URLSearchParams(location.search).get('preview_theme_id');
    if(preview)root.querySelectorAll('[data-mu-product-link]').forEach(link=>{const url=new URL(link.href);url.searchParams.set('preview_theme_id',preview);link.href=url.toString();});
    apply();
  };
  document.querySelectorAll('[data-mu-root]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-mu-root]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
